export default __webpack_public_path__ + "static/media/_avatar-4.8bc41f8a.jpg";